import { Language, MultipleVerticalsTypes } from '@/__generated__/globalTypes';
import { Recurring, JobTypes, JobHours } from './common';

export type MultiVerticalServiceType =
  | 'CHILDCARE'
  | 'SENIRCARE'
  | 'TUTORINGX'
  | 'HOUSEKEEP'
  | 'PETCAREXX';

export type PetcareServiceOption = {
  amount: number | ``;
  petCarePricingUnit: string;
  petCareSubService: string;
};

interface PetObject {
  name: string;
  isSelected: boolean;
}
export interface ProviderMVState {
  city: string;
  state: string;
  zipcode: string;
  distance: number;
  photo?: { thumbnailUrl?: string };
  lat?: number | null;
  lng?: number | null;
  initialAccountCreationAttempted: boolean;
  caregiverPreferencesPersisted: boolean;
  firstName: string;
  lastName: string;
  headline: string;
  hourlyChildCareRate: number;
  hourlyTutoringRate: number;
  hourlySeniorCareRate: number;
  hourlyHousekeepingRate: number;
  hourlyPetCareRate: number;
  providerPayRange: number[];
  ishourlyTutoringRateUpdated: boolean;
  ishourlyHousekeepingRateUpdated: boolean;
  ishourlySeniorCareRateUpdate: boolean;
  bio: string;
  recurringJob: boolean;
  oneTime: boolean;
  defaultRatePerChild: Array<number>;
  defaultRecurringHourlyRate: Array<number>;
  min: string;
  max: string;
  hours: string;
  numberOfJobsNear: number;
  recurring: Recurring;
  jobTypes: Array<JobTypes>;
  jobTypesSchedules: Partial<{
    [key in JobTypes]: JobHours;
  }>;
  languages: Language[];
  selectedAboutMe: string[];
  selectedHelpWith: string[];
  selectedSkills: string[];
  education: string;
  experienceYears: number;
  numberOfChildren: number;
  ageGroups: string[];
  callProviderNameUpdateMutation: boolean;
  textAnalysisValidationId: string;
  testCellCookieProvider?: string;
  serviceType: MultiVerticalServiceType;
  secondaryVertical: Array<MultipleVerticalsTypes> | MultipleVerticalsTypes[];
  pets: PetObject[];
  petCareSubtypeRates: PetcareServiceOption[];
}

export type ProviderMVAction =
  | {
      type: 'setProviderMVLocation';
      zipcode: string;
      city: string;
      state: string;
      lat?: number | null;
      lng?: number | null;
    }
  | { type: 'setProviderMVDistance'; distance: number }
  | { type: 'setProviderMVMemberPhoto'; photo: { url: string; thumbnailUrl: string } }
  | {
      type: 'setProviderMVInitialAccountCreationAttempted';
      initialAccountCreationAttempted: boolean;
    }
  | { type: 'setProviderMVCaregiverPreferencesPersisted'; caregiverPreferencesPersisted: boolean }
  | { type: 'setMVFirstName'; firstName: string }
  | { type: 'setMVLastName'; lastName: string }
  | { type: 'setMVHeadline'; headline: string }
  | { type: 'setMVChildCareHourlyRate'; hourlyChildCareRate: number }
  | { type: 'setMVTutoringHourlyRate'; hourlyTutoringRate: number }
  | { type: 'setMVSeniorCareHourlyRate'; hourlySeniorCareRate: number }
  | { type: 'setMVHousekeepingHourlyRate'; hourlyHousekeepingRate: number }
  | { type: 'setMVPetCareHourlyRate'; hourlyPetcareRate: number }
  | { type: 'setMVProviderPayRange'; providerPayRange: number[] }
  // these actions tell if the user has updated the hourly rate for secondary verticals they selected
  | { type: 'setMVTutoringRateUpdated'; ishourlyTutoringRateUpdated: boolean }
  | { type: 'setMVSeniorCareRateUpdated'; ishourlySeniorCareRateUpdated: boolean }
  | { type: 'setMVHousekeepingRateUpdated'; ishourlyHousekeepingRateUpdated: boolean }
  | { type: 'setMVBio'; bio: string }
  | { type: 'setRecurringJob'; recurringJob: boolean }
  | { type: 'setOneTime'; oneTime: boolean }
  | { type: 'setDefaultRatePerChild'; defaultRatePerChild: Array<number> }
  | { type: 'setDefaultRecurringHourlyRate'; defaultRecurringHourlyRate: Array<number> }
  | { type: 'setInputValuesForJobTypes'; min: string; max: string; hours: string }
  | { type: 'setProviderMVRecurringData'; data: Recurring }
  | { type: 'setJobTypes'; jobTypes: Array<JobTypes> }
  | { type: 'setJobTypesSchedule'; name: JobTypes; key: 'min' | 'max'; value: string }
  | { type: 'setNumberOfJobsNear'; numberOfJobsNear: number }
  | { type: 'setProviderMVSelectedAboutMe'; selectedAboutMe: string[] }
  | { type: 'setProviderMVSelectedHelpWith'; selectedHelpWith: string[] }
  | { type: 'setProviderMVSelectedSkills'; selectedSkills: string[] }
  | { type: 'setProviderMVEducation'; education: string }
  | { type: 'setProviderMVExperienceYears'; experienceYears: number }
  | { type: 'setProviderMVComfortableCaringFor'; numberOfChildren: number }
  | { type: 'setProviderMVAgegroups'; ageGroups: string[] }
  | { type: 'setProviderMVLanguages'; languages: Language[] }
  | { type: 'setCallProviderNameUpdateMutation'; callProviderNameUpdateMutation: boolean }
  | { type: 'setTextAnalysisValidationId'; textAnalysisValidationId: string }
  | { type: 'setProviderMVServiceType'; serviceType: MultiVerticalServiceType }
  | {
      type: 'setProviderMVSecondaryVertical';
      secondaryVertical: Array<MultipleVerticalsTypes> | [];
    }
  | { type: 'updatePetObject'; value: Array<PetObject> }
  | { type: 'setProviderPetCareRate'; value: Array<PetcareServiceOption> }
  | { type: 'setProviderMVZipCode'; value: string };

export enum ProviderFreeGatedDefaultRates {
  MIN_RATE = 14,
  MAX_RATE = 40,
  MAX_CHILDREN = 4,
}
